const openingTimers = new WeakMap<HTMLElement, ReturnType<typeof setTimeout>>();

/** Opens the action strip with the navigator's delayed full-hover appearance. */
export function showTreeMenu(menu: HTMLElement): void {
  if (menu.style.visibility === "visible") return;
  if (
    menu.hasAttribute(
      "popover", // no itx
    ) &&
    !menu.matches(":popover-open") // no itx
  )
    menu.showPopover();
  menu.style.visibility = "visible";
  menu.classList.remove("fullVisible"); // no itx
  clearTimeout(openingTimers.get(menu));
  openingTimers.set(
    menu,
    setTimeout(() => {
      if (menu.isConnected && menu.style.visibility === "visible") menu.classList.add("fullVisible"); // no itx
      openingTimers.delete(menu);
    }, 200),
  );
}

/** Closes the strip and cancels a pending hover transition. */
export function hideTreeMenu(menu: HTMLElement): void {
  clearTimeout(openingTimers.get(menu));
  openingTimers.delete(menu);
  menu.style.visibility = "hidden";
  menu.classList.remove("fullVisible");
  if (menu.matches(":popover-open")) menu.hidePopover();
}
